import React, {useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import {AuthorizedContextProvider} from "../context/AuthorizedContext";
import AuthenticatedUserLayout from "../layouts/AuthenticatedUserLayout";
import CloseBottomBar from "../components/core/CloseBottomBar";
import {Button} from "@material-ui/core";
import {Helmet} from "react-helmet";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import queryString from 'query-string';
import {useNavigate, useLocation} from "react-router-dom";
import CommunicatorCreateCommentComponents
    from "../components/page-communicator-comment-create/CommunicatorCreateCommentComponents";

import {FormikValues} from "formik";
import {HOME_OVERVIEW_PAGE_PATH} from "../layouts/navigation/Navigator";
import Loader from "../components/core/Loader";
import { normalizeToString } from '../utils/QueryParamNormalizerUtils';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
            marginBottom: 80
        },
        loader: {
            "& .MuiCircularProgress-root": {
                maxWidth: 30,
                maxHeight: 30,
                margin: 0
            }
        }
    })
);

const CommunicatorCreateCommentPage = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {search} = useLocation();

    const {redirect} = queryString.parse(search);

    const formRef = useRef<FormikValues>();
    const [isSubmitting, setIsSubmitting] = useState(false);

    return (<AuthorizedContextProvider>

            <Helmet>
                <title>{t("page.title.communicator")}</title>
                <meta name="description" content={t("page.title.communicator")}/>
            </Helmet>

            <div className={classes.root}>
                <AuthenticatedUserLayout pageTitle={t("page.title.communicator-message-create")}>

                    <CommunicatorCreateCommentComponents formRef={formRef}/>

                </AuthenticatedUserLayout>
            </div>

            <CloseBottomBar executeClose={() => navigate(normalizeToString(redirect) ?? HOME_OVERVIEW_PAGE_PATH)}>
                {isSubmitting ? <div className={classes.loader}><Loader/></div> :
                    <Button variant="contained" color="primary" size="small" type="submit" onClick={() => {
                        setIsSubmitting(true);
                        formRef.current?.submitForm().then(() => setIsSubmitting(false));
                    }}>
                        {t("buttons.submit")}
                    </Button>}
            </CloseBottomBar>

        </AuthorizedContextProvider>
    )
};

export default CommunicatorCreateCommentPage;